import Modal from 'react-modal';
import { IPixAccountViewModel } from 'viewModels';
import { CardAccounts } from '../../Cards/CardAccounts';

interface Props {
  isOpen: boolean;
  selectedPix: IPixAccountViewModel;
  onRequestClose: () => void;
}
export function ModalViewPix({ isOpen, selectedPix, onRequestClose }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName="react-modal-overlay"
      className="react-view-accounts-modal-content">
      <CardAccounts type="pix" pixAccountSelected={selectedPix} />
    </Modal>
  );
}
